import { useTokenData } from "@/context/TokenDataContext";
import { AWAITING_LAUNCH } from "@/config/tokenData";
import { BRAND } from "@/config/kingbullish";
import { formatPrice, formatCompactUsd } from "@/lib/format";

export const BuyTokenInfo = ({ address, ready }) => {
  const { token, isLoading, isError, isPreLaunch, isSimulated } = useTokenData();
  const status = isLoading ? "LOADING DATA" : isError ? "DATA UNAVAILABLE" : isSimulated ? "SIMULATION" : isPreLaunch ? AWAITING_LAUNCH : "LIVE";
  const rows = [
    ["token", "TOKEN", BRAND.ticker], ["network", "NETWORK", BRAND.chain],
    ["contract", "CONTRACT", ready ? address : "Awaiting Launch"],
    ["price", "PRICE", formatPrice(token?.currentPrice)],
    ["market-cap", "MARKET CAP", formatCompactUsd(token?.currentMarketCap)],
    ["status", "STATUS", status],
  ];
  return <section className="buy-token-info" aria-labelledby="buy-token-info-heading" data-testid="buy-token-info">
    <h2 className="buy-section-title" id="buy-token-info-heading" data-testid="buy-token-info-heading">TOKEN INFORMATION</h2>
    <dl>{rows.map(([id, label, value]) => <div key={id}>
      <dt data-testid={`buy-token-${id}-label`}>{label}</dt>
      <dd data-testid={`buy-token-${id}`} data-contract={id === "contract"}>{value}</dd>
    </div>)}</dl>
  </section>;
};